import { render, staticRenderFns } from "./account.vue?vue&type=template&id=5dc246a4&scoped=true"
import script from "./account.vue?vue&type=script&lang=ts"
export * from "./account.vue?vue&type=script&lang=ts"
import style0 from "./account.vue?vue&type=style&index=0&id=5dc246a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc246a4",
  null
  
)

export default component.exports